import {axios as http} from "@/plugins/http"

export default class Api {
    static changeDeleted(postId) {
        return http.post('/api/v1/post/change-deleted', {
            post_id: postId,
        })
    }
}
